import React from "react";

const GridContainer = ({ children, ...props }) => {
  const gridContainerStyle = {
    display: "grid",
    width: "100%",
    gridTemplateColumns: `repeat( ${props.repeat || "auto-fit"} , minmax(${props.minWidth || "1fr"}, ${
      props.maxWidth || "1fr"
    }))`,
    gap: props?.gap || "16px",
    ...props.style,
  };

  return (
    <div className="grid__container" {...props} style={gridContainerStyle}>
      {children}
    </div>
  );
};

export default GridContainer;
